export default __webpack_public_path__ + "static/media/story_img_case3.a6ab3329.jpg";